import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m16.704 3.71-.29.29L20 7.586l.288-.289h.001l.008-.009.05-.055a3.348 3.348 0 0 0 .642-1.111c.114-.344.16-.711.085-1.09-.074-.371-.28-.824-.781-1.325s-.954-.707-1.325-.781a2.1 2.1 0 0 0-1.09.085 3.35 3.35 0 0 0-1.166.692zM18.586 9 15 5.414l-11 11V20h3.586zM19.36.965c.8.16 1.598.58 2.347 1.328s1.168 1.546 1.328 2.347c.159.793.05 1.52-.149 2.114a5.34 5.34 0 0 1-1.16 1.934l-.011.012-.005.004-.001.002h-.001L21 8l.707.707-13 13A1 1 0 0 1 8 22H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 .293-.707l13-13L16 3a95 95 0 0 1-.706-.708l.002-.002.004-.004.012-.012a3 3 0 0 1 .145-.132 5.344 5.344 0 0 1 1.789-1.028 4.1 4.1 0 0 1 2.114-.15",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }